import { all, put, takeLatest, select, race, take, call } from "redux-saga/effects";
import { delay } from "@redux-saga/core/effects";
import { createRequest } from "../../tools";
import {
  FETCH_INFO_INTERVENTO,
  START_POLLING,
  STOP_POLLING,
  fetchInfoIntervento,
  fetchInfoInterventoSuccess,
  updateTimeInfo,
  incrementCallNumber,
  preparaDatiIntervento,
  comparaDatiIntervento,
  getInfoIntervento,
  getCallNumber,
  // infoInterventoMocked,
} from "./index";
import { getConfigStore } from "../configuration";
import { notificationCodes, resetNotification, setNotification } from "../notification";
import {
  INTERVENTO_204_TITLE,
  INTERVENTO_204_MESSAGE,
  INTERVENTO_NUOVI_DATI_TITLE,
  INTERVENTO_NUOVI_DATI_MESSAGE,
  SERVIZIO_NON_DISPONIBILE_TITLE,
  SERVIZIO_NON_DISPONIBILE_MESSAGE,
} from "../language";

function* fetchInfoInterventoWorker(action) {
  const { idStruttura, idPaziente } = action;
  try {
    yield put(incrementCallNumber());
    const response = yield createRequest("POST", "/surgerytracker/patient/patientStatus", null, null, { idStruttura, idPaziente }, { polling: "N" }); //prettier-ignore
    // const response = { data: infoInterventoMocked, status: 200 };
    if (response.status === 200) {
      const infoIntervento = preparaDatiIntervento(idStruttura, response.data);
      yield put(resetNotification());
      yield put(fetchInfoInterventoSuccess(infoIntervento));
      yield put(updateTimeInfo());
    } else if (response.status === 204) {
      yield put(fetchInfoInterventoSuccess(null));
      yield put(setNotification(notificationCodes.ERROR, INTERVENTO_204_TITLE, INTERVENTO_204_MESSAGE));
    } else throw response.message;
  } catch (e) {
    console.error("Errore durante il recupero delle informazioni di sala operatoria:", e);
    const callNumber = yield select(getCallNumber);
    if (e.response.status === 503 && callNumber < 4) {
      yield delay(Math.random() * 1000 + 500);
      yield put(fetchInfoIntervento(idStruttura, idPaziente));
    } else {
      yield put(fetchInfoInterventoSuccess(null));
      yield put(setNotification(notificationCodes.ERROR, SERVIZIO_NON_DISPONIBILE_TITLE, SERVIZIO_NON_DISPONIBILE_MESSAGE)); //prettier-ignore
    }
    //TODO Togliere quando servizi funzionano
    // const infoIntervento = preparaDatiIntervento(idStruttura, infoInterventoMocked);
    // yield put(fetchInfoInterventoSuccess(infoIntervento));
    // yield put(updateTimeInfo());
  }
}

function* pollingTaskWorker(action) {
  while (true) {
    const { idStruttura, idPaziente } = action;
    const config = yield select(getConfigStore);
    try {
      const situazionePrecedente = yield select(getInfoIntervento);
      if (config && config.pollingInterval && config.pollingInterval !== undefined) {
        const response = yield createRequest("POST", "/surgerytracker/patient/patientStatus", null, null, { idStruttura, idPaziente }, { polling: "S" }); //prettier-ignore
        if (response.status === 200) {
          yield put(updateTimeInfo());
          const comparata = comparaDatiIntervento(idStruttura, response.data, situazionePrecedente);
          if (comparata.datiCambiati) {
            yield put(fetchInfoInterventoSuccess(comparata.infoIntervento));
            yield put(setNotification(notificationCodes.SUCCESS, INTERVENTO_NUOVI_DATI_TITLE, INTERVENTO_NUOVI_DATI_MESSAGE)); //prettier-ignore
          }
        } else throw response.message;
        yield delay(config.pollingInterval + Math.random() * 3000);
      } else throw new Error("Non è stato specificato il tempo di polling");
    } catch (e) {
      console.error("Errore durante il polling delle informazioni di sala operatoria:", e);
      if (config && config.pollingInterval && config.pollingInterval !== undefined)
        yield delay(config.pollingInterval + Math.random() * 3000);
    }
  }
}

function* fetchInfoInterventoWatcher() {
  yield takeLatest(FETCH_INFO_INTERVENTO, fetchInfoInterventoWorker);
}

function* startPollingWatcher() {
  while (true) {
    const action = yield take(START_POLLING);
    yield race({
      task: call(pollingTaskWorker, action),
      cancel: take(STOP_POLLING),
    });
  }
}

export function* surgeryWatchers() {
  yield all([fetchInfoInterventoWatcher(), startPollingWatcher()]);
}
